export const actionTypes = {
  UPDATE_PROFILE: 'UPDATE_PROFILE',
  UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
};

export const updateProfile = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.UPDATE_PROFILE,
  callback,
  payload: data,
});
